module.exports = __webpack_public_path__ + "img/1.cbb78d1b.png";